var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2V22H22V2Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2L6.99854 7.00146L12 2H2Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2V12L6.99854 7.00146L2 2Z",
    fill: "#009AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L7.00146 6.99854L2 12H12Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12V2L7.00146 6.99854L12 12Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2V12L16.9985 7.00146L12 2Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12L17.0015 6.99854L12 12H22Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12L6.99854 17.0015L12 12H2Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12V22L6.99854 17.0015L2 12Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22L7.00146 16.9985L2 22H12Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22V12L7.00146 16.9985L12 22Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L16.9985 17.0015L22 12H12Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12V22L16.9985 17.0015L12 12Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22L17.0015 16.9985L12 22H22Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22V12L17.0015 16.9985L22 22Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2L16.9985 7.00146L22 2H12Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12V2L17.0015 6.99854L22 12Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 14.5008L15.596 8.40381L5.87939 18.1438L9.42307 21.6875L15.596 15.6109L21.9998 21.9796V14.5008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/광주-24.9eb3f5aea68cedb9ea3045484728a733.svg";
export { ForwardRef as ReactComponent };